import { DecorClickHandler, PlaceDecor } from "./TrayItemsClickedActions/DecorClickHandler.js";
import {TraySpacer} from "./TrayPlacementTools.js"
import {AddColorHeader} from "./TrayPlacementTools.js"

/**
 * Places items when swapped to DecorTab
 * @param {Phaser.Scene} Scene the array to shuffle
 * @param {any} Tray the tray the objects sit on. Used for calculations
 */

/*ThisFunction calls its onclick handler from the bottom, as the on click needs
    to both set a backdrop 'boldstroke', delete the last backdrop, and
    then set up for the draw tool that this tab uses*/

export function DecorTab(Scene,Tray)
{
    AddColorHeader(Scene,Tray);

    var CurrentBackDrop = "";

    const ColorGroupArray = [];
    var TrayGroupArray = [];
    var DrawPattern;
    const SelectionBackDrop = Scene.add.group();
    var TinselBackGround = [];

    const PlaceAbleDecor = []; //This array is for Non-drawable decorations, such as bow,candle,etc..

    const DepthList = Scene.DepthList;

    PlaceAbleDecor[0] = Scene.addImage(176,164, "Grlnd_Bow");
    ColorGroupArray.push(PlaceAbleDecor[0]);

    const RowHeights = [30,20,13,13,39,13,13,13,30,30,30];
    const RowPlacement = [];

    for (let x = 0; x < RowHeights.length;x++)
    {
        //console.log(x);
        ////console.log(RowHeights.length-1)
        if(x == 0)
        {
            RowPlacement[x] = 186 + (RowHeights[x]*.5)+20;
        }
        else
        {
            RowPlacement[x] = RowPlacement[x-1] + ((RowHeights[x]*.5) + (RowHeights[x-1])*.5) + 20;
        }
    }

    //console.log(RowPlacement);

    const MultiColorGarlandOrder = [
        0x83FF00,
        0x266CF9,
        0xBE6FF4,
        0xF70D0D,
        0xFF7900,
        0xFFDD00
    ];

    const GarlandFirstRow = TraySpacer(Tray,9,13,0,40);

    const GarlandSecondRow = TraySpacer(Tray,15,8,0,38);

    const GarlandThirdRow = TraySpacer(Tray,6,30,1,3);

    const GarlandFourthRowBall = TraySpacer(Tray,7,20,10);

    const GarlandFourthRowPepperMint = TraySpacer(Tray,6,10,20);

    const GarlandFithRow = TraySpacer(Tray,16,12,0); //Reused For Rows 6,8,9,10

    const GarlandSevenithRow = TraySpacer(Tray,11,16,0);

    const GarlandElevenithRow = TraySpacer(Tray,6,30,1); //Reused for 12 and 13

    var DecorTrayObject = {
        Row1: [],
        Row2: [],
        Row3: [],
        Row4: [],
        Row5: [],
        Row6: [],
        Row7: [],
        Row8: [],
        Row9: [],
        Row10: [],
        Row11: [],
        Row12: [],
        Row13: []        
    };
    
    for (let x in GarlandFirstRow)
    {
        DecorTrayObject.Row1[x] = (Scene.addImage(GarlandFirstRow[x],150, "Grlnd_Ball"));
        DecorTrayObject.Row1[x].setInteractive();
        DecorTrayObject.Row1[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row1,"Row1");
        });
        ColorGroupArray.push(DecorTrayObject.Row1[x]);
    }

    for (let x in GarlandSecondRow)
    {
        DecorTrayObject.Row2[x] = (Scene.addImage(GarlandSecondRow[x],180, "Grlnd_Ball").setScale(.615));
        DecorTrayObject.Row2[x].setInteractive();
        DecorTrayObject.Row2[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row2,"Row2");
        });
        ColorGroupArray.push(DecorTrayObject.Row2[x]);
    }

    for (let x in GarlandThirdRow)
    {
        DecorTrayObject.Row3[x] = (Scene.addImage(GarlandThirdRow[x],RowPlacement[0], "Grlnd_Pom"));
        DecorTrayObject.Row3[x].setInteractive();
        DecorTrayObject.Row3[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row3,"Row3");
        });
        ColorGroupArray.push(DecorTrayObject.Row3[x]);
        //console.log(DecorTrayObject.Row3);

    }

    for (let x in GarlandFourthRowBall)
    {
        DecorTrayObject.Row4[x] = (Scene.addImage(GarlandFourthRowBall[x],RowPlacement[1], "Grlnd_Ball").setScale(.714));
        DecorTrayObject.Row4[x].setInteractive();
        DecorTrayObject.Row4[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row4,"Row4");
        });
        ColorGroupArray.push(DecorTrayObject.Row4[x]);
    }

    for (let x in GarlandFourthRowPepperMint)
    {
        
        DecorTrayObject.Row4.push(Scene.addImage(GarlandFourthRowPepperMint[x],RowPlacement[1], "Pprmnt_BG"));
        DecorTrayObject.Row4[DecorTrayObject.Row4.length - 1].setInteractive();
        DecorTrayObject.Row4[DecorTrayObject.Row4.length - 1].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row4,"Row4");
        });
        TrayGroupArray.push(DecorTrayObject.Row4[DecorTrayObject.Row4.length - 1]);
        TrayGroupArray.push(Scene.addImage(GarlandFourthRowPepperMint[x],RowPlacement[1], "Pprmnt_Shdw"));
        ColorGroupArray.push(Scene.addImage(GarlandFourthRowPepperMint[x],RowPlacement[1], "Pprmnt_Strps"));
        //console.log(DecorTrayObject.Row4.length);
    }

    for (let x in GarlandFithRow)
    {
        if (x % 2)
        {
            DecorTrayObject.Row5[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[2], "Grlnd_Ball_Wht"));
            TrayGroupArray.push(DecorTrayObject.Row5[x]);
        }
        else
        {
            DecorTrayObject.Row5[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[2], "Grlnd_Ball").setTint(0xF70D0D));
            ColorGroupArray.push(DecorTrayObject.Row5[x]);
        }

        DecorTrayObject.Row5[x].setInteractive();
        DecorTrayObject.Row5[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row5,"Row5");
        });
    }

    for (let x in GarlandFithRow)// see comments above @ top___ row 6
    {
        
        if (x % 2)
        {
            DecorTrayObject.Row6[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[3], "Grlnd_Ball_Dk").setTint(0xF70D0D));
        }
        else
        {
            DecorTrayObject.Row6[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[3], "Grlnd_Ball").setTint(0xF70D0D));
        }
        //DecorTrayObject.Row6[x] = (Scene.addImage(GarlandThirdRow[x],RowPlacement[0], "Grlnd_Pom"));
        DecorTrayObject.Row6[x].setInteractive();
        DecorTrayObject.Row6[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row6,"Row6");
        });
        ColorGroupArray.push(DecorTrayObject.Row6[x]);
    }

    for (let x in GarlandSevenithRow)
    {
        DecorTrayObject.Row7[x] = (Scene.addImage(GarlandSevenithRow[x],RowPlacement[4], "Grlnd_Tnsl").setTint(0xF70D0D));
        DecorTrayObject.Row7[x].setInteractive();
        DecorTrayObject.Row7[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row7,"Row7");
        });
        TinselBackGround[x] = Scene.addImage(GarlandSevenithRow[x],RowPlacement[4], "Grlnd_Tnsl").setTint(0xF70D0D);
        TinselBackGround[x].setScale(1.09);
        TinselBackGround[x].setDepth(DepthList.OrnBack);
        TinselBackGround[x].setTint(0xc4c4c4);

        ColorGroupArray.push(DecorTrayObject.Row7[x]);
    }

    for (let x in GarlandFithRow)//see comments above, row 8 
    {
        DecorTrayObject.Row8[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[5], "Grlnd_Ball").setTint(MultiColorGarlandOrder[x % 6]));
        DecorTrayObject.Row8[x].setInteractive();
        DecorTrayObject.Row8[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row8,"Row8");
        });
        TrayGroupArray.push(DecorTrayObject.Row8[x]);
    }

    for (let x in GarlandFithRow)//see comments above, row 9 
    {
        if (x % 2)
        {
            DecorTrayObject.Row9[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[6], "Grlnd_Ball").setTint(0xF70D0D));
        }
        else
        {
            DecorTrayObject.Row9[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[6], "Grlnd_Ball").setTint(0x83FF00));
        }
        DecorTrayObject.Row9[x].setInteractive();
        DecorTrayObject.Row9[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row9,"Row9");
        });
        TrayGroupArray.push(DecorTrayObject.Row9[x]);
    }

    for (let x in GarlandFithRow)//see comments above, row 10 
    {
        let GreyScale = [0,0xC1C1C1,0x353A3D]
        if ((x % 3))
        {
            DecorTrayObject.Row10[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[7], "Grlnd_Ball").setTint(GreyScale[x%3]));
        }
        else
        {
            DecorTrayObject.Row10[x] = (Scene.addImage(GarlandFithRow[x],RowPlacement[7], "Grlnd_Ball"));
        }
        DecorTrayObject.Row10[x].setInteractive();
        DecorTrayObject.Row10[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row10,"Row10");
        });
        TrayGroupArray.push(DecorTrayObject.Row10[x]);
    }

    for (let x in GarlandElevenithRow) 
    {
        DecorTrayObject.Row11[x] = (Scene.addImage(GarlandElevenithRow[x],RowPlacement[8], "Grlnd_Pom").setTint(MultiColorGarlandOrder[x % 6]));
        DecorTrayObject.Row11[x].setInteractive();
        DecorTrayObject.Row11[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row11,"Row11");
        });
        TrayGroupArray.push(DecorTrayObject.Row11[x]);
    }

    for (let x in GarlandElevenithRow)//see comments above, row 12 
    {
        if (x % 2)
        {
            DecorTrayObject.Row12[x] = (Scene.addImage(GarlandElevenithRow[x],RowPlacement[9], "Grlnd_Pom").setTint(0xF70D0D));
        }
        else
        {
            DecorTrayObject.Row12[x] = (Scene.addImage(GarlandElevenithRow[x],RowPlacement[9], "Grlnd_Pom").setTint(0x83FF00));
        }
        DecorTrayObject.Row12[x].setInteractive();
        DecorTrayObject.Row12[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row12,"Row12");
        });
        TrayGroupArray.push(DecorTrayObject.Row12[x]);
    }

    for (let x in GarlandElevenithRow)//see comments above, row 13 
    {
        let GreyScale = [0,0xC1C1C1,0x353A3D]
        if ((x % 3))
        {
            DecorTrayObject.Row13[x] = (Scene.addImage(GarlandElevenithRow[x],RowPlacement[10], "Grlnd_Pom").setTint(GreyScale[x%3]));

        }
        else
        {
            DecorTrayObject.Row13[x] = (Scene.addImage(GarlandElevenithRow[x],RowPlacement[10], "Grlnd_Pom"));
        }
        DecorTrayObject.Row13[x].setInteractive();
        DecorTrayObject.Row13[x].on('pointerdown',function()
        {
            SetBackDrop(DecorTrayObject.Row13,"Row13");
        });
        TrayGroupArray.push(DecorTrayObject.Row13[x]);
    }

    PlaceAbleDecor[1] = Scene.addImage(153,720, "Grlnd_Cndl");
    PlaceAbleDecor[2] = Scene.addImage(206,720, "Grlnd_Flwr");
    PlaceAbleDecor[3] = Scene.addImage(287,689, "Snow1");
    PlaceAbleDecor[4] = Scene.addImage(287,723, "Snow2");
    PlaceAbleDecor[5] = Scene.addImage(258,749, "Snow3");
    PlaceAbleDecor[6] = Scene.addImage(311,748, "Snow4");
    
    TrayGroupArray.push(PlaceAbleDecor[1]);
    TrayGroupArray.push(PlaceAbleDecor[2]);
    TrayGroupArray.push(PlaceAbleDecor[3]);
    TrayGroupArray.push(PlaceAbleDecor[4]);
    TrayGroupArray.push(PlaceAbleDecor[5]);
    TrayGroupArray.push(PlaceAbleDecor[6]);

    for(let x in PlaceAbleDecor)
    {
        PlaceAbleDecor[x].setInteractive();

        PlaceAbleDecor[x].on('pointerdown',function(Pointer)
        {
            PlaceDecor(this,Pointer,SelectionBackDrop);
        });
        PlaceAbleDecor[x].x -= 210;
    }

    TrayGroupArray = ColorGroupArray.concat(TrayGroupArray);

    Scene.TrayGroup.addMultiple(TrayGroupArray);

    Scene.ColorGroup.addMultiple(ColorGroupArray);

    Scene.ColorGroup.getChildren().forEach(element =>
        {
            element.setTint(0xF70D0D);
        });

    Scene.TrayGroup.getChildren().forEach(element =>
        {
            element.setDepth(DepthList.OrnMiddle);
        });

    Scene.TrayGroup.addMultiple(TinselBackGround);
    _widenHitBox(DecorTrayObject);

    //Scene.TrayGroup.clear(true,true);

    /**This sets up an on click for the back shadow of the selected draw tool
     * also will call the function that calls DecorClickHandler
     * 
     * @param {*} RowArray the array of objects in the row
     * @param {String} RowName name of the array,used to avoid multiple backdrops
     */
    function SetBackDrop(RowArray,RowName,DrawArray)
    {
        if (CurrentBackDrop != RowName)
        {
            Scene.AudioChan.Chan5.play('click_in_game');
            //console.log("Not the smae");
            DrawPattern = DrawArray;
            CurrentBackDrop = RowName;
            SelectionBackDrop.clear(true,true);
            for(let x in RowArray)
            {
                let BackDrop = Scene.addImage(RowArray[x].x,RowArray[x].y, RowArray[x].frame.name);
                BackDrop.setScale(RowArray[x].scale + .4);
                BackDrop.setTint(0x000000);
                BackDrop.setDepth(DepthList.OrnBack);
                SelectionBackDrop.add(BackDrop);
                Scene.TrayGroup.add(BackDrop);
            }
            // SelectionBackDrop.getChildren().forEach(element =>
            //     {
            //         Scene.TrayGroup.add(element);
            //         element.setDepth(Scene.DepthList.OrnBack);
            //     });

            DecorClickHandler(RowArray,RowName,DrawArray,Scene);
        }
    }
}

function _widenHitBox(FullArray)
{
    for(let x in FullArray)
    {
        switch(x)
        {
            case "Row1":
                FullArray[x][0].input.hitArea.setTo(0,-10,117,33);
                break;
            case "Row2":
                FullArray[x][0].input.hitArea.setTo(0,-14,130,42);
                break;
            case "Row7":
                break;
            case "Row3":
                break;
            case "Row4":
                break;
            case "Row5":
            case "Row6":
            case "Row8":
            case "Row9":
            case "Row10":
                FullArray[x][0].input.hitArea.setTo(0,-10,224,33);
                break;
            case "Row11":
                break;
            case "Row12":
                break;
            case "Row13":
                break;
            default:
                break;
        }
        //FullArray[x][0].input.hitArea.setTo(0,-10,,);
    }
}